export const storeIdConverter = (value) => {
    const _value = value.toString().trim();
    const baseValue = Number(_value.startsWith("C") ? _value.substr(1) : Number(_value) - 5000);
    return {
        withC: "C" + baseValue.toString(),
        asNumber: Number(Number(baseValue) + 5000)
    }
}